import { useGetSkillsQuery } from "../skillsSlice";

const useSkills = () => {
  const skills = useGetSkillsQuery();
  return skills;
};

export default useSkills;
